<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="630"
    >
      <h3 slot="header" class="modal-header">添加角色</h3>
      <Form :label-width="120">
        <FormItem label="角色名称" class="ivu-form-item-required">
          <Input class="item-width" v-model="roleName"></Input>
        </FormItem>
        <FormItem label="所属应用" class="ivu-form-item-required">
          <Select  class="item-width" placeholder="请选择" v-model="appType" @on-change="getMenu">
            <Option v-for="item in appTypeList" :value="item.value" :key="'keyB'+item.value">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="功能菜单" class="ivu-form-item-required noselected" >
          <div class="item-width"
               style="padding-left: 10px;height: 320px;overflow: auto;border: 1px solid #dcdcdc;">
            <Tree :data="data" :multiple="true" show-checkbox ref="tree"></Tree>
          </div>
          <a href="javascript:void(0)" @click.stop="toCopy">权限复制</a>
        </FormItem>
      </Form>
      <character-list :n="pN" :appType="appType" @getRole="getRoles"></character-list>
    </Modal>
  </div>


</template>
<script>
  import CharacterList from './CharacterList'
  import {menuTree} from "../../../../api/menu";
  import {rolegetByIds} from "../../../../api/character";
  import {setTitleAndOthers, setCheckedFromData} from "../../js/systemmanage";
  import {roleadd} from "../../../../api/character";
  import {deepClone} from "../../../../utils/format";

  export default {
    name: "",
    components: {
      CharacterList
    },
    props: {
      n: {
        type: Number,
        default: 0
      },

    },
    watch: {
      n() {
        this.roleName = '';
        this.permIds=[];
        this.appType=null;
        this.data = [];
        this.isShow = true
        this.appType = 3;
        this.getMenu();
      }
    },
    data() {
      return {
        pN: 0,
        data: [],
        loading: true,
        isShow: false,
        roleName: '',
        appType:null,
        permIds: [],
        appTypeList:[{text:'一三环境',value:3}],
      }
    },
    methods: {
      setPermIds() {

        if(!this.data.length){
          return []
        }

        let arrCheck = [];

        function dealArr(arr,parent) {
          arr.forEach(ele=>{
            let parenEle=deepClone(parent)
            if(ele.children && ele.children.length){
              parenEle.push(ele.parentValue);
              parenEle.push(ele.value)
              dealArr(ele.children,parenEle)
            }
            if (!ele.children || ele.children.length === 0) {
              if(ele.checked){
                parenEle.push(ele.value);
                arrCheck = arrCheck.concat(parenEle)
              }
            }

          })
        }
        dealArr(this.data,[])

        let res = [];
        let json = {};
        for (let i = 0; i < arrCheck.length; i++) {
          if (!json[arrCheck[i]]) {

            res.push(arrCheck[i]);

            json[arrCheck[i]] = 1;
          }
        }
        return res

      },

      getRoles(value) {
        rolegetByIds({ids: value}).then(res => {
          //设置筛选状态
          if (!res.data || res.data.length === 0) {
            return
          }
          setCheckedFromData(this.data, res.data)

        }).catch(error => {
        })
      },
      menuTree() {
        if(!this.appType){
          return
        }
        menuTree({appType:this.appType}).then(res => {
          if (!res.data) {
            return
          }
          setTitleAndOthers(res.data);
          this.data = res.data
        }).catch(error => {
        })
      },
      toCopy() {
        this.pN++
      },
      getMenu(){
        if(!this.appType){
          return
        }
        this.menuTree();
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!(this.roleName + '')) {
          this.$Message.info('请输入角色名称！');
          this.changeLoading();
          return
        }
        if (!(this.appType)) {
          this.$Message.info('请选择所属应用！');
          this.changeLoading();
          return
        }
        this.permIds=this.setPermIds();
        let params = {
          permIds: this.permIds,
          appType: this.appType,
          roleName: this.roleName
        };
        roleadd(params).then(res => {
          this.$Message.success('添加成功');
          this.$emit('done')
        }).catch(error => {

        }).finally(() => {
          this.isShow = false
        })
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .item-width {
    width: 300px;
  }

</style>
